<template>
	<div>
		<v-date-picker
			@input="onSelectedDate"
			v-model="date"
			:color="color"
			:is-range="isRange"
			:is-expanded="isExpanded"
		></v-date-picker>
	</div>
</template>

<script>
import Vue from 'vue';

import VCalendar from 'v-calendar';
import '@/assets/css/custom-v-calendar.css';

Vue.use(VCalendar);

export default {
	props: {
		isRange: {
			type: Boolean,
			default: false,
		},
		isExpanded: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'gray',
		},
	},
	data() {
		return {
			date: '',
		};
	},
	methods: {
		onSelectedDate() {
			this.$emit('callbackSelectedDate', this.date);
		},
	},
};
</script>
